export default {
  UNREDEEMED: 0,
  REDEEM_SUCCESS: 1,
  INTERNAL_REDEEM_FAILED: 2,
  PRAKERJA_REDEEM_FAILED: 3
}
